import { useI18n } from '@udemy/i18n';
import classNames from 'classnames';
import React from 'react';
import styles from "./carousel.module.css";
/**
 * Component props for `CarouselSlide`
 */

/**
 * A slide component for the carousel.
 *
 * @param children - Slide contents
 *
 * @remarks
 *
 * To follow accessible carousel patterns, `CarouselSlide` should be
 * rendered either with `aria-label` or `aria-labelledby` props to
 * provide an accessible name for the slide contents.
 *
 * Avoid using the word "slide" in the accessible name for the slide.
 *
 * See https://www.w3.org/WAI/ARIA/apg/patterns/carousel/
 *
 * Slides may contain multiple items, or multiple slides may
 * be visible in the carousel at the same time. However, they
 * all must have an accessible name.
 */
export const CarouselSlide = _ref => {
  let {
    'aria-roledescription': ariaRoledescription,
    children,
    className,
    role = 'group',
    ...props
  } = _ref;
  const {
    gettext
  } = useI18n();
  return /*#__PURE__*/React.createElement("div", Object.assign({
    className: classNames(className, styles['scroll-item']),
    role: role,
    "aria-roledescription": ariaRoledescription !== null && ariaRoledescription !== void 0 ? ariaRoledescription : gettext('slide')
  }, props), children);
};
//# sourceMappingURL=carousel-slide.react-component.js.map